import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import type { Article, Category } from '@/types/content';

export const getCategoryName = (slug: string): string => {
  const found = categories.find((item: Category) => item.slug === slug);
  return found ? found.name : '全部';
};

export const getCategoryBySlug = (slug: string): Category | undefined =>
  categories.find((item: Category) => item.slug === slug);

export const getArticleById = (id: string): Article | undefined =>
  articles.find((item: Article) => item.id === id);

export const getArticlesByCategory = (slug: string): Article[] =>
  articles.filter((item: Article) => item.category === slug);

export const getRelatedArticles = (article: Article, limit = 3): Article[] => {
  const sameCategory = articles.filter(
    (item: Article) => item.category === article.category && item.id !== article.id,
  );
  const others = articles.filter(
    (item: Article) => item.category !== article.category && item.id !== article.id,
  );
  return [...sameCategory, ...others].slice(0, limit);
};

export const getHotArticles = (limit = 5): Article[] =>
  [...articles].sort((a: Article, b: Article) => b.views - a.views).slice(0, limit);

export const searchArticles = (keyword: string): Article[] => {
  const key = keyword.trim().toLowerCase();
  if (!key) return articles;
  return articles.filter(
    (item: Article) =>
      item.title.toLowerCase().includes(key) ||
      item.excerpt.toLowerCase().includes(key) ||
      item.tags.some((tag: string) => tag.toLowerCase().includes(key)) ||
      getCategoryName(item.category).toLowerCase().includes(key),
  );
};

export const sortArticles = (list: Article[], sort: string): Article[] => {
  const copy = [...list];
  if (sort === 'hot') {
    return copy.sort((a: Article, b: Article) => b.views - a.views);
  }
  if (sort === 'like') {
    return copy.sort((a: Article, b: Article) => b.likes - a.likes);
  }
  return copy.sort(
    (a: Article, b: Article) => new Date(b.date).getTime() - new Date(a.date).getTime(),
  );
};

export const formatCount = (value: number): string => {
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return `${value}`;
};

export const formatDate = (value: string): string => {
  const date = new Date(value);
  return `${date.getMonth() + 1} 月 ${date.getDate()} 日`;
};

export { articles, categories };